import {
    FC,
    FormEvent,
    ReactElement,
    useState,
} from 'react'
import { useDispatch } from 'react-redux'

import { forgotUserPassword } from '../../../redux/authentication/authenticationActions'
import { Button } from '../../components'
import { LinkButton } from '../../components/@buttons/LinkButton/LinkButton'
import { TextInput } from '../../compositions'
import { LoginLayout } from '../../containers'
import { RequestPasswordResetFormData } from '../../entities/@forms/RequestPasswordResetForm/RequestPasswordResetForm'
import trans from '../../helpers/trans'
import { useTypedSelector } from '../../redux/store'
import { AuthRoutes } from '../../routes/subRoutes/authRoutes'
import { RequestPasswordResetFormErrors, validateRequestPasswordResetFormData } from './validations'

import './RequestPasswordReset.scss'

const RequestPasswordReset: FC = (): ReactElement => {
    const dispatch = useDispatch()

    const { isLoading } = useTypedSelector(state => state.authenticationReducer)

    const [email, setEmail] = useState<string>('')
    const [forgotPasswordRequested, setForgotPasswordRequested] = useState<boolean>(false)
    const [formErrors, setFormErrors] = useState<RequestPasswordResetFormErrors>({})

    const handleSubmit = (event: FormEvent<HTMLFormElement>): void => {
        event.preventDefault()

        const formData: RequestPasswordResetFormData = { email }

        const [errors, hasErrors] = validateRequestPasswordResetFormData(formData)

        setFormErrors(errors)

        if (! hasErrors) {
            setForgotPasswordRequested(true)
            dispatch(forgotUserPassword(formData.email))
        }
    }

    return (
        <LoginLayout>
            <div className="request-password-reset-page">
                <h4 className="request-password-reset-page__title">
                    {trans('pages.requestPasswordReset.forgotPassword')}
                </h4>

                <p>
                    {trans('pages.requestPasswordReset.intro')}
                </p>

                <form
                    onSubmit={handleSubmit}
                    className="request-password-reset-page__form"
                >
                    <TextInput
                        hideLabel
                        required
                        autoComplete="email"
                        type="email"
                        label={trans('common.email')}
                        error={formErrors.email}
                        placeholder={trans('common.email')}
                        disabled={forgotPasswordRequested}
                        onChange={setEmail}
                        className="request-password-reset-page__input"
                    />

                    {forgotPasswordRequested && (
                        <p>
                            {trans('pages.requestPasswordReset.requested')}
                        </p>
                    )}

                    <div className="request-password-reset-page__buttons-container">
                        <LinkButton
                            to={`/${AuthRoutes.login()}`}
                            text={trans('common.back')}
                            color="link"
                        />

                        {! forgotPasswordRequested && (
                            <Button
                                type="submit"
                                text={trans('common.back')}
                                disabled={isLoading}
                                color="orange"
                                className="request-password-reset-page__submit-button"
                            >
                                {trans('common.send')}
                            </Button>
                        )}
                    </div>
                </form>
            </div>
        </LoginLayout>
    )
}

export default RequestPasswordReset
